import {FITH2Symbol, ISymbolData, FITH2SymbolStates} from "./FITH2Symbol";
import {gsap} from "gsap";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2Helper} from "../utils/FITH2Helper";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";

export class FITH2Wild extends FITH2Symbol {

    constructor(symbolData: ISymbolData, state: FITH2SymbolStates = FITH2SymbolStates.NORMAL) {
        super(symbolData);
        this._spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("W"));
        if (!this.isBehindDirt) {
            this.addChild(this._spine);
            this._currentStateSprite.visible = false;
            this._spine.state.setAnimation(0, "base", false);
        }
    }

    public playLandingAnimation(): gsap.core.Timeline {
        if (this.isBehindDirt) {
            return gsap.timeline();
        }

        return gsap.timeline().add([
            () => {
                this.parent.removeChild(this);
                FireInTheHole2.reelArea.allReels[this.reelId].reelView.scatterWinView.addChild(this);
                FITH2SoundManager.playWildLandingSound()
            },
            new SpineTween(this._spine!, 0, "base")
        ]);
    }

    public explode(winType: string, barId: number = -1): gsap.core.Timeline {
        if (this._id === barId) {
            this.isBehindBar = false;
        }
        if (this._isRemoved || this.isBehindBar) {
            return gsap.timeline();
        }

        if (this.isBehindDirt) {
            return this.removeDirt(false);
        }

        if (FireInTheHole2.model.gameData.wildMiningTriggered) {
            return gsap.timeline();
        }
        const tl = gsap.timeline();
        this._isRemoved = true;
        tl.add([
            () => {
                this.parent.removeChild(this);
                FireInTheHole2.reelArea.allReels[this.reelId].reelView.fullWildSymbolWinView.addChild(this);
            },
            new SpineTween(this._spine!, 0, "explode")
        ], 0);
        if (this._multiplier) {
            tl.add(gsap.to(this._multiplier, 7 * 0.033, {alpha: 0, delay: 10 * 0.033}), 0);
        }
        tl.add(() => {
            if (this._isRemoved) {
                this.remove();
            }
        });
        return tl;
    }

    protected removeDirt(fromSplit: boolean = true): gsap.core.Timeline {
        return super.removeDirt(fromSplit).add(() => {
            this._currentStateSprite.visible = false;
            this.addChild(this._spine!);
            if (this._multiplier) {
                this.addChild(this._multiplier);
            }
            this._spine!.state.setAnimation(0, "base", false);
        });
    }

    //Wild mining
    public playWildMining(): SpineTween {
        this.parent.removeChild(this);
        FireInTheHole2.reelArea.allReels[this.reelId].reelView.scatterWinView.addChild(this);
        return new SpineTween(this._spine!, 0, "combin");
    }
}